import React from 'react';
import { motion } from 'framer-motion';

import { AppWrap } from '../../wrapper';
import './Header.scss';

const Header = () => {
	return (
		<div className="app__header app__flex">
			<motion.div
				whileInView={{ x: [-100, 0], opacity: [0, 1] }}
				transition={{ duration: 1.5 }}
				className="app__header-info">
				<div className="app__header-badge">
					<div className="badge-cmp app__flex">
						<div>
							<p className="p-text">
								<span>&lt;p&gt;</span> <br /> hi there, my name is <br />
								<span>&lt;/p&gt;</span>
							</p>
							<h1 className="head-text neonText">
								<span aria-hidden="true">Vitalik-Hakim</span>Vitalik-Hakim
								<span aria-hidden="true">Vitalik-Hakim</span>
							</h1>
						</div>
					</div>

					<div className="tag-cmp app__flex">
						<p className="p-text">
							<i>
								<span>&lt;i&gt; </span>
								<br />
								a Student and  developer with a passion for design and development
								of modern responsive web applications
								<br />
								<span> &lt;/i&gt;</span>
							</i>
						</p>
					</div>
				</div>
			</motion.div>

			<motion.div
				whileInView={{ opacity: [0, 1] }}
				transition={{ duration: 1.5, delayChildren: 1.5 }}
				className="app__header-img">
				<svg
					id="app__header-img_svg"
					width="816"
					height="106"
					viewBox="0 0 816 106"
					fill="none"
					xmlns="http://www.w3.org/2000/svg">
					<mask
						id="path-1-outside-1_2_6"
						maskUnits="userSpaceOnUse"
						x="0.6297"
						y="0.23999"
						width="815"
						height="106"
						fill="black">
						<rect
							fill="white"
							x="0.6297"
							y="0.23999"
							width="815"
							height="106"
						/>
						<path d="M65.1017 7.39999C65.1017 7.39999 63.8057 6.96798 61.7897 6.53599C59.7737 6.24798 57.6137 5.95999 57.6137 5.95999H5.6297V9.70399V26.12H52.4297V26.264H55.7417L55.8857 26.12C56.0297 26.12 56.1737 26.12 56.3177 26.12C60.2057 26.12 63.2297 29.288 63.2297 33.032C63.2297 36.92 60.2057 39.944 56.3177 39.944H25.7897H5.6297V101H25.7897V60.248H58.3337C58.3337 60.248 58.9097 60.248 62.5097 59.384C66.1097 58.52 66.2537 58.376 66.2537 58.376C69.9977 56.792 73.4537 54.488 76.1897 51.464C80.9417 46.568 83.3897 39.944 83.3897 33.032C83.3897 21.224 75.9017 11.144 65.1017 7.39999Z" />
						<path d="M137.381 6.24799C111.173 6.24799 90.0047 27.56 90.0047 53.624C90.0047 79.832 111.173 101 137.381 101C163.445 101 184.757 79.832 184.757 53.624C184.757 27.56 163.445 6.24799 137.381 6.24799ZM164.885 53.624C164.885 68.888 152.501 81.272 137.381 81.272C122.117 81.272 109.733 68.888 109.733 53.624C109.733 38.504 122.117 26.12 137.381 26.12C152.501 26.12 164.885 38.504 164.885 53.624Z" />
						<path d="M284.452 95.24L257.236 50.6C257.38 50.6 257.524 50.456 257.668 50.312L257.812 50.168C257.956 50.168 258.1 50.024 258.1 49.88C258.388 49.736 258.532 49.592 258.82 49.448C258.964 49.304 259.252 49.016 259.54 48.872C259.54 48.728 259.684 48.728 259.684 48.728C259.828 48.584 260.116 48.296 260.26 48.152C260.836 47.576 261.412 47.144 262.132 46.424C268.612 39.944 273.22 31.88 275.092 22.952C275.956 19.496 276.244 16.04 276.244 12.584C276.244 11.432 276.244 10.28 276.1 9.27199L275.956 5.67198H196.036V25.832H239.236H252.628C251.332 28.136 249.748 30.296 247.876 32.024C245.428 34.472 242.692 36.344 239.524 37.784C239.38 37.784 239.38 37.784 239.236 37.928C235.924 39.224 232.324 39.944 228.724 39.944H196.036V101H216.196V60.248H228.724C229.012 60.248 229.3 60.104 229.588 60.104H229.732H229.876H230.164C230.452 60.104 230.596 60.104 230.884 60.104C231.028 60.104 231.172 60.104 231.172 60.104C231.46 60.104 231.748 60.104 232.036 60.104H232.324L232.468 59.96C232.756 59.96 233.044 59.96 233.476 59.96C233.764 59.96 234.052 59.816 234.484 59.816C234.628 59.816 234.772 59.816 234.916 59.816C235.204 59.672 235.492 59.672 235.78 59.672C235.924 59.672 236.068 59.672 236.212 59.528C236.356 59.528 236.644 59.528 236.932 59.528C237.508 59.384 238.084 59.24 238.66 59.096L263.14 99.272L264.292 101H287.908L284.452 95.24Z" />
						<path d="M341.961 101V40.232H321.801V101H341.961ZM289.833 5.95999V26.12H321.801H341.961H375.513V5.95999H289.833Z" />
						<path d="M389.958 43.976V60.392V101H410.118V60.392H466.422V40.232H389.958V43.976ZM474.918 26.12V5.95999H389.958V26.12H474.918Z" />
						<path d="M528.881 6.24799C502.673 6.24799 481.505 27.56 481.505 53.624C481.505 79.832 502.673 101 528.881 101C554.945 101 576.257 79.832 576.257 53.624C576.257 27.56 554.945 6.24799 528.881 6.24799ZM556.385 53.624C556.385 68.888 544.001 81.272 528.881 81.272C513.617 81.272 501.233 68.888 501.233 53.624C501.233 38.504 513.617 26.12 528.881 26.12C544.001 26.12 556.385 38.504 556.385 53.624Z" />
						<path d="M610.93 80.84V5.23999H590.77V101H666.37V80.84H610.93Z" />
						<path d="M680.911 5.81599V101H701.071V5.81599H680.911Z" />
						<path d="M762.881 6.24799C736.673 6.24799 715.505 27.56 715.505 53.624C715.505 79.832 736.673 101 762.881 101C788.945 101 810.257 79.832 810.257 53.624C810.257 27.56 788.945 6.24799 762.881 6.24799ZM790.385 53.624C790.385 68.888 778.001 81.272 762.881 81.272C747.617 81.272 735.233 68.888 735.233 53.624C735.233 38.504 747.617 26.12 762.881 26.12C778.001 26.12 790.385 38.504 790.385 53.624Z" />
					</mask>
					<path
						d="M65.1017 7.39999C65.1017 7.39999 63.8057 6.96798 61.7897 6.53599C59.7737 6.24798 57.6137 5.95999 57.6137 5.95999H5.6297V9.70399V26.12H52.4297V26.264H55.7417L55.8857 26.12C56.0297 26.12 56.1737 26.12 56.3177 26.12C60.2057 26.12 63.2297 29.288 63.2297 33.032C63.2297 36.92 60.2057 39.944 56.3177 39.944H25.7897H5.6297V101H25.7897V60.248H58.3337C58.3337 60.248 58.9097 60.248 62.5097 59.384C66.1097 58.52 66.2537 58.376 66.2537 58.376C69.9977 56.792 73.4537 54.488 76.1897 51.464C80.9417 46.568 83.3897 39.944 83.3897 33.032C83.3897 21.224 75.9017 11.144 65.1017 7.39999Z"
						stroke="#F7F7F7"
						strokeWidth="10"
						mask="url(#path-1-outside-1_2_6)"
					/>
					<path
						d="M137.381 6.24799C111.173 6.24799 90.0047 27.56 90.0047 53.624C90.0047 79.832 111.173 101 137.381 101C163.445 101 184.757 79.832 184.757 53.624C184.757 27.56 163.445 6.24799 137.381 6.24799ZM164.885 53.624C164.885 68.888 152.501 81.272 137.381 81.272C122.117 81.272 109.733 68.888 109.733 53.624C109.733 38.504 122.117 26.12 137.381 26.12C152.501 26.12 164.885 38.504 164.885 53.624Z"
						stroke="#F7F7F7"
						strokeWidth="10"
						mask="url(#path-1-outside-1_2_6)"
					/>
					<path
						d="M284.452 95.24L257.236 50.6C257.38 50.6 257.524 50.456 257.668 50.312L257.812 50.168C257.956 50.168 258.1 50.024 258.1 49.88C258.388 49.736 258.532 49.592 258.82 49.448C258.964 49.304 259.252 49.016 259.54 48.872C259.54 48.728 259.684 48.728 259.684 48.728C259.828 48.584 260.116 48.296 260.26 48.152C260.836 47.576 261.412 47.144 262.132 46.424C268.612 39.944 273.22 31.88 275.092 22.952C275.956 19.496 276.244 16.04 276.244 12.584C276.244 11.432 276.244 10.28 276.1 9.27199L275.956 5.67198H196.036V25.832H239.236H252.628C251.332 28.136 249.748 30.296 247.876 32.024C245.428 34.472 242.692 36.344 239.524 37.784C239.38 37.784 239.38 37.784 239.236 37.928C235.924 39.224 232.324 39.944 228.724 39.944H196.036V101H216.196V60.248H228.724C229.012 60.248 229.3 60.104 229.588 60.104H229.732H229.876H230.164C230.452 60.104 230.596 60.104 230.884 60.104C231.028 60.104 231.172 60.104 231.172 60.104C231.46 60.104 231.748 60.104 232.036 60.104H232.324L232.468 59.96C232.756 59.96 233.044 59.96 233.476 59.96C233.764 59.96 234.052 59.816 234.484 59.816C234.628 59.816 234.772 59.816 234.916 59.816C235.204 59.672 235.492 59.672 235.78 59.672C235.924 59.672 236.068 59.672 236.212 59.528C236.356 59.528 236.644 59.528 236.932 59.528C237.508 59.384 238.084 59.24 238.66 59.096L263.14 99.272L264.292 101H287.908L284.452 95.24Z"
						stroke="#F7F7F7"
						strokeWidth="10"
						mask="url(#path-1-outside-1_2_6)"
					/>
					<path
						d="M341.961 101V40.232H321.801V101H341.961ZM289.833 5.95999V26.12H321.801H341.961H375.513V5.95999H289.833Z"
						stroke="#F7F7F7"
						strokeWidth="10"
						mask="url(#path-1-outside-1_2_6)"
					/>
					<path
						d="M389.958 43.976V60.392V101H410.118V60.392H466.422V40.232H389.958V43.976ZM474.918 26.12V5.95999H389.958V26.12H474.918Z"
						stroke="#F7F7F7"
						strokeWidth="10"
						mask="url(#path-1-outside-1_2_6)"
					/>
					<path
						d="M528.881 6.24799C502.673 6.24799 481.505 27.56 481.505 53.624C481.505 79.832 502.673 101 528.881 101C554.945 101 576.257 79.832 576.257 53.624C576.257 27.56 554.945 6.24799 528.881 6.24799ZM556.385 53.624C556.385 68.888 544.001 81.272 528.881 81.272C513.617 81.272 501.233 68.888 501.233 53.624C501.233 38.504 513.617 26.12 528.881 26.12C544.001 26.12 556.385 38.504 556.385 53.624Z"
						stroke="#F7F7F7"
						strokeWidth="10"
						mask="url(#path-1-outside-1_2_6)"
					/>
					<path
						d="M610.93 80.84V5.23999H590.77V101H666.37V80.84H610.93Z"
						stroke="#F7F7F7"
						strokeWidth="10"
						mask="url(#path-1-outside-1_2_6)"
					/>
					<path
						d="M680.911 5.81599V101H701.071V5.81599H680.911Z"
						stroke="#F7F7F7"
						strokeWidth="10"
						mask="url(#path-1-outside-1_2_6)"
					/>
					<path
						d="M762.881 6.24799C736.673 6.24799 715.505 27.56 715.505 53.624C715.505 79.832 736.673 101 762.881 101C788.945 101 810.257 79.832 810.257 53.624C810.257 27.56 788.945 6.24799 762.881 6.24799ZM790.385 53.624C790.385 68.888 778.001 81.272 762.881 81.272C747.617 81.272 735.233 68.888 735.233 53.624C735.233 38.504 747.617 26.12 762.881 26.12C778.001 26.12 790.385 38.504 790.385 53.624Z"
						stroke="#F7F7F7"
						strokeWidth="10"
						mask="url(#path-1-outside-1_2_6)"
					/>
				</svg>
			</motion.div>
		</div>
	);
};

export default AppWrap(Header, 'home');
